import { atom } from "jotai";
import type { SegmentationMarkSet } from "../predictions/segmentationMarks";

/**
 * The study's AI slice marks, ticked on each pane's slice bar: a mask-localized
 * finding's segments, or the key slices a host rail flags (device panel).
 * Steady state (what the marks ARE), so an atom rather than a bus event —
 * each ProtocolViewport reads it on mount and filters to its own series.
 *
 * null when there is nothing to mark, e.g. a classification device's study.
 */
export const segmentationMarksAtom = atom<SegmentationMarkSet | null>(null);
